/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { orderBy } from "lodash";
import { yearToCropYearShort, OLAPTransformerResult, castUnit, GLOBAL_UNIT } from "../../../shared";
import Highcharts from "highcharts";
import { TableProps } from "../../../components/Table";
import { CATEGORIES_AXIS, SERIES_AXIS } from "../../Report6/constants";

export function useChart2(data: OLAPTransformerResult | null, orderedCountriesIds: number[] | null, unit: number | null): TableProps | undefined {
  const [state, setState] = useState<TableProps | undefined>();
  const colKey = `${CATEGORIES_AXIS}.name`;

  const categories = useMemo(
    () => {
      const resultCategories = orderBy(data?.columns || [], c => orderedCountriesIds?.indexOf(Number(c.selection[CATEGORIES_AXIS]))).map((x) => `${x.headers.find((h) => h.id === colKey)?.name}`) || []
      return resultCategories;
    },
    [data, orderedCountriesIds],
  );

  useEffect(() => {
    if (data) {
      const rows = data?.rows.map((x) => {
        const period = x.attributes[`${SERIES_AXIS}.name`]
        const records = {
          Period: yearToCropYearShort(period) || "",
          rawPeriod: period
        };
        for (const point of orderBy(x.points, p => orderedCountriesIds?.indexOf(p.column.selection[CATEGORIES_AXIS] as number))) {
          const col = point.attributes ? point.attributes[colKey] : '';
          records[col] = Highcharts.numberFormat(
            castUnit(point.value, GLOBAL_UNIT.AREA_MHA, unit || GLOBAL_UNIT.DISPLAY_AREA) || 0 // TODO: Fix
            , 1);
        }
        return records;
      });
      const result: TableProps = {
        columns: ["Period"].concat(categories).map((x) => ({ headerName: x, field: x, resizable: true, initialSortIndex: categories.indexOf(x) })),
        rows,
      };
 
      setState(result);
    } else {
      setState(undefined);
    }
  }, [data, categories, unit, orderedCountriesIds]);
  return state;
}
